import { render } from "./menu1-1.vue?vue&type=template&id=45e8dfc1"
import script from "./menu1-1.vue?vue&type=script&lang=ts"
export * from "./menu1-1.vue?vue&type=script&lang=ts"
script.render = render

export default script